<script setup lang="ts">
const benefits = [
  {
    title: 'Return Rate Turun Signifikan',
    description: 'Deteksi pola retur dan ambil tindakan preventif.',
    icon: 'material-symbols:history-toggle-off',
    iconSize: '33px'
  },
  {
    title: 'Proses Menjadi Lebih Cepat',
    description: 'Otomatisasi retur memperepat penyelesaian & klaim.',
    icon: 'material-symbols:bolt-outline',
    iconSize: '33px'
  },
  {
    title: 'Kepercayaan Pelanggan Naik',
    description: 'Transparansi retur meningkatkan loyalitas pelanggan.',
    icon: 'material-symbols:trending-up',
    iconSize: '33px'
  },
  {
    title: 'Insight untuk Keputusan Strategis',
    description:
      'Gunakan data RMS untuk meningkatkan kualitas layanan & produk.',
    icon: 'material-symbols:thumb-up-outline',
    iconSize: '33px'
  }
]
</script>

<template>
  <section class="bg-surface-container-low">
    <UiContainer class="py-12 flex flex-col gap-6 lg:gap-16">
      <UiSectionTitle
        class="text-center"
        title="Dari Operasional Rumit Jadi Sistem yang Efisien"
      />
      <div class="grid grid-cols-1 gap-6 lg:grid-cols-4">
        <UiCardFeature
          v-for="(benefit, index) in benefits"
          :key="index"
          :icon="benefit.icon"
          :icon-size="benefit.iconSize"
          :title="benefit.title"
          :description="benefit.description"
        />
      </div>
      <div class="grid lg:grid-cols-2 gap-6">
        <UiCard class="p-0 relative">
          <NuxtImg
            src="/images/solusi/rms/before.webp"
            class="aspect-[1003/600] w-full"
            width="500px"
            height="300px"
            alt="Before using KiriminAja"
          />
        </UiCard>
        <UiCard class="p-0 relative">
          <NuxtImg
            src="/images/solusi/rms/after.webp"
            class="aspect-[1003/600] w-full"
            width="500px"
            height="300px"
            alt="After using KiriminAja"
          />
        </UiCard>
      </div>
    </UiContainer>
  </section>
</template>
